import React from 'react'
import PropTypes from 'prop-types'
import { EditSponsorsForm } from 'local/components'

const SponsorsAddComponent = ({ onSubmit }) => (
  <EditSponsorsForm header="Add Sponsor" onSubmit={onSubmit} />
)

SponsorsAddComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default SponsorsAddComponent
